import React, { useEffect } from "react";
import { X } from "lucide-react";

// Display-only enlarged view of the SAME public image (no re-upload/regeneration).
const ProductLightbox = ({ src, alt, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[120] bg-black/85 flex items-center justify-center p-3 sm:p-8 overflow-hidden" onClick={onClose} data-testid="product-lightbox" role="dialog" aria-modal="true">
      <button type="button" onClick={onClose} aria-label="إغلاق" data-testid="product-lightbox-close"
        className="absolute top-3 right-3 sm:top-5 sm:right-5 w-12 h-12 rounded-full bg-white/95 text-[#333333] flex items-center justify-center shadow-lg hover:bg-white z-10">
        <X size={26} />
      </button>
      <img src={src} alt={alt || ""} onClick={(e) => e.stopPropagation()} data-testid="product-lightbox-image"
        className="max-w-full max-h-full w-auto h-auto object-contain rounded-lg shadow-2xl select-none" style={{ maxHeight: "calc(100vh - 2rem)", maxWidth: "calc(100vw - 1.5rem)" }} />
    </div>
  );
};

export default ProductLightbox;
